import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  BedrockPromptKMSKeyARN,
  BedrockPromptVariantModelIDs,
  BedrockPromptVariantNames,
  BedrockPromptVariantTemplateTypes,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockPromptMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state="None"
        availabilityZone="None"
        vpc="None"
        owner="None"
        createdAt={metadata}
        updatedAt={metadata}
      />
      {BedrockPromptVariantNames(metadata)}
      {BedrockPromptVariantTemplateTypes(metadata)}
      {BedrockPromptVariantModelIDs(metadata)}
      {BedrockPromptKMSKeyARN(metadata)}
    </Grid>
  );
};
